import React from 'react'
import PropTypes from 'prop-types'

import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatDateTime } from '../../../../util/datetime'
import ToggleButton from '../../../form/component/ToggleButton'
import currentUserHasAccess from '../../../../util/widget-helper'
import { SENT_EMAIL_WIDGET } from '../../../process/ui-definition/process-ui'


const placeMessageInHtml = (messageHtml) => {
    return '<html><style>span {font-family: Arial, "Helvetica Neue", Helvetica, sans-serif; color:#344644} a {color: #3498db}</style><body>' + messageHtml + '</body></html>'
}


const Time = ({ time }) => {
    if (!time) {
        return null
    }
    return formatDateTime(time)
}


class SentEmailList extends React.Component {
    iframeList

    constructor (props) {
        super(props)
        this.iframeList = {}
        this.state = {
            sentEmailListOpen: {},
        }
        this.toggleMessageVisibility = this.toggleMessageVisibility.bind(this)
    }

    componentWillReceiveProps (nextProps) {
        this.setState({
            sentEmailListOpen: {},
        })
    }

    toggleMessageVisibility (messageId) {
        this.setState({
            sentEmailListOpen: {
                ...this.state.sentEmailListOpen,
                [messageId]: !this.state.sentEmailListOpen[messageId],
            },
        })
    }

    componentDidUpdate () {
        for (let index = 0; index < this.props.sentEmailList.length; index++) {
            const message = this.props.sentEmailList[index]
            const iFrame = this.iframeList[message.id]
            if (!iFrame) {
                continue
            }
            if (!message.text) {
                continue
            }
            const frameDocument = iFrame.contentWindow
            const messageHtml = placeMessageInHtml('<span><b>' + message.subject + '</b></span><br/><br/>' + message.text)
            frameDocument.document.open()
            frameDocument.document.write(messageHtml)
            frameDocument.document.close()
        }
    }


    render () {
        if (!currentUserHasAccess(SENT_EMAIL_WIDGET)) {
            return null
        }

        const { sentEmailList } = this.props
        return (
            <ContentBox title="Emails">
                <Row>
                    <Column size={12}>
                        <table className="default-table">
                            <thead>
                                <tr>
                                    <th width="40%">
                                    Name
                                    </th>
                                    <th width="10%">
                                    Variant
                                    </th>
                                    <th width="10%">
                                    Delivered
                                    </th>
                                    <th width="10%">
                                    Opened
                                    </th>
                                    <th width="10%">
                                    Clicked
                                    </th>
                                    <th width="10%">
                                    Spam/Blocked
                                    </th>
                                    <th width="10%" className="align-right">Show/Hide</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sentEmailList.map(sentEmail => {
                                    const rows = []
                                    const open = !!this.state.sentEmailListOpen[sentEmail.id]

                                    rows.push(<tr key={sentEmail.id + '_overview'}>
                                        <td>{sentEmail.messageName}</td>
                                        <td>{sentEmail.variant}</td>
                                        <td><Time time={sentEmail.delivered}/></td>
                                        <td><Time time={sentEmail.opened}/></td>
                                        <td><Time time={sentEmail.click}/></td>
                                        <td><Time time={sentEmail.spam}/><Time time={sentEmail.blocked}/></td>
                                        <td className="align-right">
                                            {sentEmail.text && (<ToggleButton
                                                toggle={() => {
                                                    this.toggleMessageVisibility(sentEmail.id)
                                                }}
                                                active={open}
                                                activeIcon="fa fa-search-minus"
                                                inactiveIcon="fa fa-search-plus"/>)}
                                        </td>
                                    </tr>)

                                    if (!open) {
                                        return rows
                                    }

                                    rows.push(<tr key={sentEmail.id + '_iframe'}>
                                        <td colSpan={6}>
                                            <iframe
                                                frameBorder="1"
                                                title="Email Content"
                                                ref={(iFrame) => {
                                                    this.iframeList[sentEmail.id] = iFrame
                                                }}
                                                className="customer-transaction-email-iframe"
                                            />
                                        </td>
                                    </tr>)


                                    return rows
                                })}
                            </tbody>
                        </table>
                    </Column>
                </Row>
            </ContentBox>
        )
    }
}


SentEmailList.propTypes = {
    sentEmailList: PropTypes.array,
}

export default SentEmailList



// WEBPACK FOOTER //
// ./src/modules/email/component/sent/SentEmailList.js